module.exports = __webpack_public_path__ + "static/media/gone-fishing.203ef178.bmp";